import { render, staticRenderFns } from "./Group_Rating.vue?vue&type=template&id=25d862c6&scoped=true"
import script from "./Group_Rating.vue?vue&type=script&lang=js"
export * from "./Group_Rating.vue?vue&type=script&lang=js"
import style0 from "./Group_Rating.vue?vue&type=style&index=0&id=25d862c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d862c6",
  null
  
)

export default component.exports